var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHiredCandidates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 303.924,
    height: 197.357,
    viewBox: "0 0 303.924 197.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.j{fill:#c5c9f6;}.a,.g{opacity:0.95;}.b,.g{fill:#fff;}.c{fill:#0d37c9;}.d{fill:#e9a4b3;}.e{fill:#040227;}.f{fill:#d998a9;}.h{fill:#16d696;}.i{fill:#393d63;}.k{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 61.586,
    width: 144.718,
    height: 131.231,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-907.704 -99.876)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(377.893 -297.631)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 188.628,
    height: 188.628,
    rx: 26,
    transform: "translate(645.107 406.235)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 87.331,
    height: 4.314,
    transform: "translate(695.756 551.919)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 62.593,
    height: 4.314,
    transform: "translate(708.125 565.513)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(675.402 397.507)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M842.4,583.875c-4.187-11.077-14.247-16.163-19-17.748-1.691-.561-4.712-1.547-7.894-2.577-5.735-1.853-12-3.869-12-3.869H783.725s-6.852,2.3-14.135,4.849a.006.006,0,0,1-.006.006c-6.708,2.352-13.773,4.918-16.157,6.116-4.974,2.483-13.342,20.237-15.033,22.272-.874,1.049-4.755,7.963-8.574,15.689h21.317c2.253-3.869,3.987-6.871,3.987-6.871s1.348,2.958,2.983,6.871h68.3c1.08-4.543,1.754-10.266,1.754-10.266s3.657,4.974,7.651,10.266H855.49C850.7,600.581,844.763,590.128,842.4,583.875Z",
    transform: "translate(-729.82 -501.685)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.642 3.473)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M881.556,407.365s15.472,2.438,13.117,26.646-16.012,22.224-16.925,22.2-13.709.442-14.706-29.115C863.041,427.094,862.606,405.238,881.556,407.365Z",
    transform: "translate(-863.041 -407.219)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.614 22.629)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M950.547,461.582s1.694-1.81,2.316.022-2.311,10-2.416,10.385c0,0-.309.711-.716.32S950.547,461.582,950.547,461.582Z",
    transform: "translate(-949.648 -460.784)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.642 22.295)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M859.867,460.676s-1.659-1.842-2.316-.023,2.092,10.045,2.216,10.43c0,0,.3.716.709.333S859.867,460.676,859.867,460.676Z",
    transform: "translate(-857.45 -459.85)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.855 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M891.7,424.647l-2.215,2.961s.063-6.492-.292-7.511-.9-4.128-1.2-4.861S874.7,410.863,863.23,416.3c0,0,.5,4.669-.6,5.084s-.56,7.6-.56,7.6l-1.822-2.055s-2.788-18.625-2.1-20.566,2.882-13.613,26.422-6.685c0,0,7.338-1.554,8.811,3.513S891.7,424.647,891.7,424.647Z",
    transform: "translate(-858.045 -397.507)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M881.647,531.784c-.007-.022-1.985-.975-1.985-.975-.964-2.156-.248-11.25-.248-11.25s-19.707-5.016-19.144-1.18-1.7,12.746-1.7,12.746l-10.11,5.02s10.771,28.922,23.151,25.191S888.668,535.1,888.668,535.1Z",
    transform: "translate(-806.035 -474.226)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M882.273,532.1a11.684,11.684,0,0,0,8.686,4.1c3.624,0,6.227-1.016,9.838-4.537,0,0-1.565,6.687-9.814,7.309C890.983,538.97,885,539.731,882.273,532.1Z",
    transform: "translate(-827.754 -483.686)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(677.11 425.829)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M840.906,476.7v2.659h15.655v14.693h2.659V476.7ZM734.6,494.056h2.659V479.364h15.655V476.7H734.6Zm121.964,75.812v14.7H840.906v2.659H859.22V569.869Zm-119.305,0H734.6v17.357h18.314v-2.659H737.256Z",
    transform: "translate(-734.597 -476.705)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-752.328 -114.798)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "matrix(1, 0, 0, 1, 1660.03, 214.67)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 135.718,
    height: 122.231,
    rx: 26,
    transform: "translate(4.5 65.09)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1706.033 266.71)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.809 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1840.521,269.055s8.672,4.762,5.919,16.472-3.8,13.256-1.563,17.988,4.2,24.561,1.818,28.189-26.577-17.695-29.266-34.752,3.364-24.3,5.509-27.006S1832.871,264.706,1840.521,269.055Z",
    transform: "translate(-1816.753 -266.71)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.891 43.65)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1884.79,446.827H1875.5c-.449-4.58-.864-7.768-.779-8.24.136-.779-9.24-25.373-10.115-27.407s-4.319-7.484-4.768-12.621,6.245-7.211,6.245-7.211c9.041,1.62,12.1,14.127,12.1,14.127s3.8,25.361,5.717,32.5A45.4,45.4,0,0,1,1884.79,446.827Z",
    transform: "translate(-1859.821 -391.348)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1880.407,407.451l-13.827,5.829s-12.71-31.539-2.057-28.017C1875.145,388.774,1879.923,395.373,1880.407,407.451Z",
    transform: "translate(-1833.221 -343.566)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.356 39.61)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1835.227,418.936c-.4,3.131-2.057,14.223-1.688,17.218.062.494.267,1.631.574,3.176h-33.34c.886-3.165,1.694-5.967,2.182-7.6,1.62-5.37.068-6.807-.75-11.1-.318-1.682-1.438-4.876-2.66-8.485-.409-1.2-.829-2.46-1.233-3.722a76.814,76.814,0,0,1-2.569-11.9c-2.011-12.826,7.853-14.059,7.853-14.059,3.665-.676,10.069-2.654,10.069-2.654l10.03,2.086a10.9,10.9,0,0,1,2.347,1.387.006.006,0,0,1,.006.006,18.339,18.339,0,0,1,2.256,1.977,60.591,60.591,0,0,1,5.456,7.888c.665,1.085,1.335,2.2,1.966,3.3,2.04,3.529,3.489,6.376,3.444,9.586C1839.131,409.2,1835.631,415.8,1835.227,418.936Z",
    transform: "translate(-1795.474 -379.811)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1847.273,382.055s6.284,10.739,3.947,11.541-14.653-1.91-19.464-12.056C1831.757,381.541,1839.841,377.867,1847.273,382.055Z",
    transform: "translate(-1814.694 -340.357)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1850.292,361.41s-5.581,2.362-10.635-5.413c0,0,1.358-8.829-1.514-13.936s12.55,6.122,12.55,6.122-.25,1.053-.508,2.607c-.132.8-.268,1.721-.372,2.7-.087.818-.154,1.678-.183,2.533A13.855,13.855,0,0,0,1850.292,361.41Z",
    transform: "translate(-1818.612 -314.807)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1814.208,434.126c-1.15,5.91-9.393,13.313-9.393,13.313-.408-1.208-.828-2.461-1.231-3.721A53.936,53.936,0,0,0,1814.208,434.126Z",
    transform: "translate(-1796.387 -375.495)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.236 44.037)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1801.081,411.75c-.522,2.154-2.926,23.969-2.665,24.714.153.427,1.318,5.473,2.483,11.081h-10.763c-1.1-3.614-1.756-6.615-1.6-8.314.688-7.359-1.807-30.816-1.807-30.816s-2.233-14.19,9.541-15.962c0,0,6.956.915,7.376,6.052S1801.6,409.6,1801.081,411.75Z",
    transform: "translate(-1786.564 -392.452)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1783.571,411.716l14.612,3.413s11.591-22.506,1.152-26.615C1788.331,384.183,1780.933,399.439,1783.571,411.716Z",
    transform: "translate(-1783.035 -345.368)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.625 3.007)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1848.109,275.882s12.7,4.661,4.65,26.575-24.481-3.741-22-17.208S1848.109,275.882,1848.109,275.882Z",
    transform: "translate(-1830.508 -275.295)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.16 1.187)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1853.842,285.826a29.108,29.108,0,0,1-17.458,6.262s-2.514,6.128-2.92,8.009c0,0-10.627-18.246,1.591-27.463S1858.354,282,1853.842,285.826Z",
    transform: "translate(-1829.178 -270.099)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.434 19.911)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1845.766,328.143c-.006-1.623-.83-5.354-3.285-4.437s-.256,8.541,1.362,8.155C1843.843,331.862,1845.781,331.983,1845.766,328.143Z",
    transform: "translate(-1841.383 -323.563)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1856.161,369.367c-5.968-1.651-8.276-7.339-8.346-7.529,4.853,6.271,8.514,5.37,8.514,5.37C1856.242,368.026,1856.236,368.537,1856.161,369.367Z",
    transform: "translate(-1825.128 -328.523)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1686.705 301.88)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1805.79,367.134v1.949h11.478v10.772h1.95V367.134Zm-77.944,12.722h1.95V369.083h11.478v-1.949h-13.427Zm89.422,55.585v10.776H1805.79v1.949h13.427V435.44Zm-87.472,0h-1.95v12.725h13.427v-1.949H1729.8Z",
    transform: "translate(-1727.846 -367.134)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiredCandidates);
export default __webpack_public_path__ + "static/media/hired-candidates.dcd08343d797f69cb2d378d60ea5663f.svg";
export { ForwardRef as ReactComponent };